import {Pipe, PipeTransform} from '@angular/core';
import {addDays, isBefore} from 'date-fns';
import {environment} from '../../../environments/environment';

@Pipe({
  name: 'itsNewTemplate'
})
export class ItsNewTemplatePipe implements PipeTransform {

  transform(date: string): boolean {
    return isBefore(new Date(), addDays(new Date(date), environment.DAYS_TO_CONSIDER_TEMPLATE_AS_NEW));
  }

}
